import React from 'react';
import NuAmount from '../../../../Components/Utils/NuAmount';

function UserView({ item, data, open, onCancel }) {
  const displayItem = item || data;

  return (
    <div>
    <div className="w-full flex justify-between flex-wrap gap-5">
      <div className='my-2 w-[40%]'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Job Role</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.job_role || "-"}</p>
      </div>
      <div className="my-2 w-[40%]">
  <p className="text-[13px] font-medium text-mainColor-400 py-1">Type</p>
  <p className="text-xs text-mainColor-400">
    {displayItem?.type === 0 ? "Own" : displayItem?.type === 1 ? "Rental" : "-"}
  </p>
</div>
</div>
<div className="w-full flex justify-between flex-wrap gap-5">

      <div className='my-2 w-[40%]'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Working Hours</p>
        <p className='text-xs text-mainColor-400'>{displayItem?.working_hours || "-"}</p>
      </div>
       <div className='my-2 w-[40%]'>
        <p className='text-[13px] font-medium text-mainColor-400 py-1'>Amount Per Hour</p>
        <p className='text-xs text-mainColor-400'><NuAmount value={displayItem?.amount_per_hour || "-"}/></p>
      </div>
    </div>
    </div>
  );
}
 
export default UserView;
